import { SkippedCourse, SkippedLesson } from '../../../../api-service/clients/auto-generated-clients';

export interface ICourseBulkEditResult {
  updatedCourseCount: number;
  updatedLessonCount: number;
  skippedCourses?: SkippedCourse[];
}

export interface ILessonBulkEditResult {
  updatedLessonCount: number;
  skippedLessons?: SkippedLesson[];
}

export interface ISkippedItem {
  id: string;
  name: string;
  reason: string;
}

export interface IBulkEditResultSection {
  summary: string;
  skippedItemsText: string;
  skippedItems: ISkippedItem[];
}

export type BulkEditChange = 'educators' | 'classroom';

function changeSummary(change: BulkEditChange, changedItemsText: string) {
  return change === 'educators' ? `Underviserne er rettet på ${changedItemsText}.` : `Lokalet er skiftet på ${changedItemsText}.`;
}

function lessonCountText(count: number) {
  return count === 1 ? '1 lektion' : `${count} lektioner`;
}

function futureLessonCountText(count: number) {
  return count === 1 ? '1 fremtidig lektion' : `${count} fremtidige lektioner`;
}

export function courseResultSection(change: BulkEditChange, result: ICourseBulkEditResult, includedFutureLessons: boolean): IBulkEditResultSection {
  const coursesText = `${result.updatedCourseCount} hold`;
  const changedItemsText = includedFutureLessons ? `${coursesText} og ${futureLessonCountText(result.updatedLessonCount)}` : coursesText;
  const skippedItems = (result.skippedCourses ?? []).map(skipped => ({ id: skipped.courseId, name: skipped.courseName, reason: skipped.reason }));
  return { summary: changeSummary(change, changedItemsText), skippedItemsText: `${skippedItems.length} hold blev sprunget over:`, skippedItems };
}

export function lessonResultSection(change: BulkEditChange, result: ILessonBulkEditResult): IBulkEditResultSection {
  const skippedItems = (result.skippedLessons ?? []).map(skipped => ({ id: skipped.lessonId, name: skipped.lessonName, reason: skipped.reason }));
  return {
    summary: changeSummary(change, lessonCountText(result.updatedLessonCount)),
    skippedItemsText: `${lessonCountText(skippedItems.length)} blev sprunget over:`,
    skippedItems,
  };
}
